import React, { Component } from 'react';
import AssetSection from './AssetSection';
import FormField from './../../../forms/FormField';
import { Field, FormSection, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import FieldSection from './FieldSection';
import Column from './Column';
import ArrayActions from './ArrayActions';
import ArrayError from './ArrayError';
import MapAssetFields from './MapAssetFields';
import { Row, Button } from 'react-bootstrap';

const selector = formValueSelector('asset-form');

class RenderOrArray extends Component {
  constructor(props) {
    super(props);
    this.state = { selected: null }
  }
  render() {
    const { asset, fields, values, meta, readOnly } = this.props;
    const { fields: assetFields, opts } = asset || {};

    const options = (assetFields || []).map(f => {
      const { name, label } = f.opts || {};
      return {
        value: name,
        label
      }
    });
    const value = this.state.selected || (options[0] || {}).value;

    const addField = () => {
      if (!value) return;
      fields.push({
        __type__: value
      })
    };

    const handleChange = (e) => {
      const { value } = e.target;
      this.setState({ selected: value });
    }
    return (
      <Column field={asset}>
        <div className="form-section-add">
          {!readOnly && (
            <div>
              <ArrayError {...meta} />
              <div className="form-control-btn">
                <select className="form-control" onChange={handleChange} value={value}>
                  {(options || []).map((o, index) => (
                    <option key={index} value={o.value}>{o.label}</option>
                  ))}
                </select>
                <Button onClick={addField} bsStyle="hollow-info" bsSize="sm">
                  <span className="ti ti-plus" />
                </Button>
              </div>
            </div>
          )}
          <h3>{opts.label}</h3>
        </div>

        {fields.map((f, index) => {
          // TODO test out using FieldsArray
          // console.dir(f.input.value);
          const value = values[index] || {};
          const { __type__ } = value || {};
          const asset = assetFields.find(f => f.opts.name === __type__);
          return (
            <div className="section-group" key={index}>
              <Row>
                <Column field={f} key={index}>
                  <div className="form-section-name">
                    {!readOnly && (
                      <div className="section-actions small">
                        <ArrayActions fields={fields} index={index} />
                      </div>
                    )}
                    <h5>{asset.opts.label}</h5>
                  </div>
                  <FormSection name={f}>
                    <Row>
                      <MapAssetFields asset={asset} readOnly={readOnly} />
                    </Row>
                  </FormSection>
                </Column>
              </Row>
            </div>
          )
        })}
      </Column>
    )
  }
}

export default connect((state, props) => {
  const { opts } = props.asset || {};
  const values = selector(state, `data.${opts.name}`)
  return {
    values
  };
})(RenderOrArray)



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/RenderOrArray.js